/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { patch } from "@insite/client-framework/Services/ApiService";
import { UpdateBillToApiParameter, UpdateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";

const billTosUrl = "/api/custom/customer";

export async function requestUpdateCustomer(parameter: UpdateBillToApiParameter | UpdateShipToApiParameter) {
    let customer;

    if ((parameter as any).billTo) {
        customer = (parameter as any).billTo;
        delete customer.shipTos;
    } else {
        customer = (parameter as any).shipTo;
    }

    delete customer.budgetEnforcementLevel;
    delete (customer as any).isB2B;

    const requestBody = {
        customerNumber: customer.customerNumber,
        firstName: customer.firstName,
        lastName: customer.lastName,
        city: customer.city,
        postalCode: customer.postalCode,
        country: customer.country ? customer.country.abbreviation : undefined,
        phone: customer.phone,
        email: customer.email,
        attention: customer.attention,
        companyName: customer.companyName,
        address1: customer.address1,
        address2: customer.address2,
        address3: customer.address3,
        address4: customer.address4,
        state: customer.state ? customer.state.abbreviation : undefined,
        fax: customer.fax,
        currency: customer.customerCurrencySymbol,
        id: customer.id,
    };

    // eslint-disable-next-line no-return-await
    return await patch<any>(`${billTosUrl}`, requestBody);
}
